import { COLORS, FONT_FAMILY } from './theme'
import type { PercentileRow } from './types'

interface PercentileTableProps {
  rows: PercentileRow[]
}

function fmtPct(v: number): string {
  if (!Number.isFinite(v)) return '—'
  return `${(v * 100).toFixed(2)}%`
}

function fmtNum(v: number): string {
  if (!Number.isFinite(v)) return '—'
  return v.toFixed(2)
}

export function PercentileTable({ rows }: PercentileTableProps) {
  return (
    <div className="w-full h-full flex flex-col">
      <h3 className="font-bold text-[14px] mb-2" style={{ color: COLORS.text, fontFamily: FONT_FAMILY }}>
        Tabla Percentil - Monte Carlo
      </h3>
      <div className="flex-1 overflow-auto">
        <table className="w-full text-[11px]" style={{ borderCollapse: 'collapse', fontFamily: FONT_FAMILY }}>
          <thead>
            <tr style={{ backgroundColor: COLORS.grid }}>
              {['Pct', 'Net Profit', 'Max DD', 'Win Rate', 'P. Factor'].map((header) => (
                <th
                  key={header}
                  className="p-2 text-left font-bold"
                  style={{ color: COLORS.primary, border: `1px solid ${COLORS.border}` }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.percentile} style={{ backgroundColor: COLORS.panel }}>
                <td className="p-2" style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
                  {row.percentile}
                </td>
                <td className="p-2" style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
                  {fmtPct(row.netProfit)}
                </td>
                <td className="p-2" style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
                  {fmtPct(row.maxDrawdown)}
                </td>
                <td className="p-2" style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
                  {fmtPct(row.winRate)}
                </td>
                <td className="p-2" style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
                  {fmtNum(row.profitFactor)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
